import { render, staticRenderFns } from "./commission-deduction.vue?vue&type=template&id=3390d539"
import script from "./commission-deduction.vue?vue&type=script&lang=js"
export * from "./commission-deduction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports